import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Positions")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_t, { path: "symbol_5" }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createTextVNode(" (" + _toDisplayString(_ctx.count) + ")", 1)
  ]))
}